<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M747.904 128a128 128 0 0 1 126.352 107.552l36.096 222.96A128 128 0 0 1 912 478.96V768a128 128 0 0 1-128 128H240a128 128 0 0 1-128-128V478.96a128 128 0 0 1 1.648-20.448l36.096-222.96A128 128 0 0 1 276.096 128zM208 768a32 32 0 0 0 32 32h544a32 32 0 0 0 32-32V528h-112a128 128 0 0 1-124 127.936L576 656h-128a128 128 0 0 1-127.936-124L320 528h-112z m539.904-544H276.096a32 32 0 0 0-31.6 26.88L215.168 432H368a48 48 0 0 1 47.92 45.184L416 480v48a32 32 0 0 0 29.6 31.92L448 560h128a32 32 0 0 0 31.92-29.6L608 528v-48a48 48 0 0 1 45.184-47.92L656 432h152.816l-29.312-181.12a32 32 0 0 0-29.008-26.768L747.904 224z"
    />
  </svg>
</template>
